module.exports = __webpack_public_path__ + "img/arrow_backward_circle.9d83d48c.svg";